import {rXAxis} from "./x-axis";
import {cFieldGroupAxes} from "../../../common/field-group-axes";

export const XAxes = (xAxis) => (xAxis ? Object.keys(xAxis).map((k) => rXAxis(k)) : []);
